/* eslint-disable no-console */
/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import { Box, Tab } from '@mui/material';
import {TabContext, TabPanel, TabList} from '@mui/lab';
import './argo.scss';

export default function DashboardBarchart(props) {
  const { data, conc_calc, argoProducts, sliderRecoveryValue } = props;
  const barChartData = data || [];
  const value = [];
  const keys = [];
  const d = [];
  const getColor = (value, val) => {
    if (barChartData?.graph_data_standalone?.[sliderRecoveryValue]) {
      let isRed = false;
      let isYellow = false;
      Object.keys(barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[val]).forEach((k) => {
        if (barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[val]?.[k] > 100) {
          isRed = true;
        } else if (barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[val]?.[k] > 80 &&
          barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[val]?.[k] <= 100) {
          isYellow = true;
        }
      });
      if (isRed) {
        return '#f34428';
      }
      if (isYellow) {
        return '#FFBF00';
      }
      return '#8bc63e';
    };
    return '#8bc63e';
  };
  const ButtonsKeys = ['Dosage, Kg/day', 'Dosage, ppm', 'CaCO3, %', 'CaSO4, %',
    'BaSO4, %', 'SrSO4, %', 'Fe, %', 'Al, %', 'Mn, %', 'CaF2, %', 'SiO2, %', 'CaHPO4, %', 'MgOH2, %'];
  const ALLOWED_PRODUCTS = ['MDC714', 'MDC712', 'MDC704i', 'MDC712E'];
  const [b_val, setb_val] = useState('Dosage, Kg/day');
  const [Chartvalue, setChartValue] = useState('0'); // we are selecting dosage kg/day
  const handleChange = (event, newValue) => {
    setChartValue(newValue);
    setb_val(ButtonsKeys[newValue]);
  };
  if (b_val === 'Dosage, Kg/day') {
    if (barChartData.as_ppm_dose[sliderRecoveryValue]) {
      argoProducts.map(k => {
        if (k !== 'UNTREATED') {
          keys.push(k);
          value.push(barChartData.as_ppm_dose[sliderRecoveryValue][k]);
          d.push({ x: k, y: barChartData.as_ppm_dose[sliderRecoveryValue][k] });
        }
      });
    }
  } else if (b_val === 'Dosage, ppm') {
    if (barChartData.as_ppm_brine[sliderRecoveryValue]) {
      argoProducts.map(k => {
        if (k !== 'UNTREATED') {
          keys.push(k);
          value.push(barChartData.as_ppm_brine[sliderRecoveryValue][k]);
          d.push({ x: k, y: barChartData.as_ppm_brine[sliderRecoveryValue][k] });
        }
      });
    }
  } else if (barChartData.graph_data_standalone[sliderRecoveryValue]) {
    argoProducts.map(k => {
      keys.push(k);
      value.push(barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[k]?.[b_val?.split(', ')[0]]);
      if(b_val === 'MgOH2, %'){
        if(ALLOWED_PRODUCTS.includes(k)){
          d.push({
            x: k, y: barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[k]?.[b_val?.split(', ')[0]]
          });
        }
      }else {
        d.push({
          x: k, y: barChartData?.graph_data_standalone?.[sliderRecoveryValue]?.[k]?.[b_val?.split(', ')[0]]
        });
      };
    });
    d.sort((a, b) => {
      const fa = b.x.toLowerCase();
      const fb = a.x.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
  };
  const options = {
    noData: {
      text: 'No Data',
      align: 'center',
      verticalAlign: 'middle',
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
      }
    },
    series: [
      {
        name: b_val,
        data: d
      }
    ],
    chart: {
      type: 'bar',
      parentHeightOffset: 0,
      animations: {
        enabled: false
      }
    },
    colors: [({ value, dataPointIndex, w }) => {
      const category = w.globals.labels[dataPointIndex];
      if (b_val === 'Dosage, Kg/day' || b_val === 'Dosage, ppm')
        return getColor(value, category);
      if (value > 100) {
        return '#f34428';
      } if (value >= 80 && value <= 100) {
        return '#FFBF00';
      }
      return '#8bc63e';
    }],
    plotOptions: {
      bar: {
        borderRadius: '0',
        columnWidth: '30%',
        dataLabels: {
          position: 'top' // top, center, bottom
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter(val) {
        if (b_val === 'Dosage, Kg/day' || b_val === 'Dosage, ppm') {
          if (isNaN(val))
            return 'N.A';
          return `${Number(val).toFixed(2)}`;
        }
        return `${Number(val).toFixed(2)}`;
      },
      offsetY: -30,
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        colors: ['#2C2C2C']
      }
    },
    xaxis: {
      categories: d.map((v) => v.x),
      position: 'bottom',
      labels: {
        style: {
          colors: '#55555A',
          fontSize: '8px',
          fontWeight: 600,
          cssClass: 'apexcharts-xaxis-label',
        },
        offsetY: 0
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs_: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5
          }
        }
      },
      tooltip: {
        enabled: false,
        offsetY: -35
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      min: 0,
      max: (d) => {
        if (b_val === 'Dosage, Kg/day' || b_val === 'Dosage, ppm') {
          return d < 5 ? d + 0.2 : d + 3;
        }
        return 140;
      },
      labels: {
        show: false,
        formatter(val) {
          if (b_val === 'Dosage, Kg/day' || b_val === 'Dosage, ppm') {
            if (isNaN(val))
              return 'N.A';
            return `${Number(val).toFixed(2)}`;
          }
          return `${Number(val).toFixed(2)}`;
        }
      }
    },
    grid: {
      show: false,
    },
  };

  return (
    <TabContext value={Chartvalue}>
      <Box sx={{
        maxWidth: '100%', borderColor: 'divider', padding: '24px', 'boxShadow': '0px 3px 6px #0000000D',
        border: '1px solid #F2F2F2', 'borderRadius': '6px'
      }}>
        <div className='S_Regular'>{`Concentrate composition calculated - ${conc_calc === 'argo' ? 'Argo' : 'Winflows'}`}</div>
        <TabList onChange={handleChange}
          aria-label="visible arrows tabs example"
          className='tab-list'
        >
          <Tab label='Dosage in Feed(ppm)' color='default' value='0' className='B_Bold' />
          <Tab label='Dosage in Brine(ppm)' color='default' value='1' className='B_Bold' />
          <Tab label='CaCO3, %' color='default' value='2' className='B_Bold' />
          <Tab label='CaSO4, %' color='default' value='3' className='B_Bold' />
          <Tab label='BaSO4, %' color='default' value='4' className='B_Bold' />
          <Tab label='SrSO4, %' color='default' value='5' className='B_Bold' />
          <Tab label='Fe, %' color='default' value='6' className='B_Bold' />
          <Tab label='Al, %' color='default' value='7' className='B_Bold' />
          <Tab label='Mn, %' color='default' value='8' className='B_Bold' />
          <Tab label='CaF2, %' color='default' value='9' className='B_Bold' />
          <Tab label='SiO2, %' color='default' value='10' className='B_Bold' />
          <Tab label='CaHPO4, %' color='default' value='11' className='B_Bold' />
          {/* <Tab label='MgOH2, %' color='default' value='12' className='B_Bold' /> */}
        </TabList>
        <TabPanel value="0" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel>
        <TabPanel value="1" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="2" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="3" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="4" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="5" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="6" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="7" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="8" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="9" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="10" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="11" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel><TabPanel value="12" className='tab-panel'>
          <Chart id="dashboard_bar" options={options} series={options.series} type="bar" width="100%" height='150' />
        </TabPanel>
      </Box>
    </TabContext>
  );
}
